import { EventType } from '@ispm/shared/bpmn-io/bpmn-js';
import { NodeCreationResult } from '@ispm-client/modules/bpmn-modeler/models/node-creation-result';
import EventBus from 'diagram-js/lib/core/EventBus';
import { PathwaysModeling } from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import { State } from '@ispm-client/modules/bpmn-modeler/store/state';
import { select, Store } from '@ngrx/store';
import { selectNodeCreationInfoById } from '@ispm-client/modules/bpmn-modeler/store/selectors';
import { map, take } from 'rxjs/operators';
import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';
import { map as lodashMap, without } from 'lodash';
import { NodeType } from '@ispm/shared/bpmn-io/node-type';

/**
 * Created By Elia Rohana on 2/14/19
 */
export class AddConnectionEndBehavior {

    constructor(private eventBus: EventBus, private pathwaysModeling: PathwaysModeling, private store$: Store<State>) {
        this.addOnConnectEnd();
    }

    private addOnConnectEnd() {
        this.eventBus.on(EventType.CONNECT_END, event => {
            const targetNodeType = ModelingUtil.getNodeType(event.context.target);
            if (targetNodeType === NodeType.treatment) { // ignore in case the target is treatment
                return;
            }
            const context = event.context,
                source = context.source,
                gateway = context.target;
            const outgoingConnections = gateway.outgoing;
            let updatedSourceElement;
            if (outgoingConnections.length > 0) { // init element children
                updatedSourceElement = this.pathwaysModeling.createSubProcessChildren(source);
            }

            this.getChildrenData$(outgoingConnections.map(a => a.target.id))
                .subscribe((nodeCreationResultsData: Array<NodeCreationResult>) => {
                    if (nodeCreationResultsData) {
                        this.pathwaysModeling.calculateChildsData(updatedSourceElement, nodeCreationResultsData);
                    }
                    outgoingConnections.forEach((connection, index) => {
                        const childNode = connection.target;
                        const childNodeType = ModelingUtil.getNodeType(childNode);
                        this.eventBus.fire(EventType.NODE_UPDATED, {
                            node: childNode,
                            nodeCreationResult: nodeCreationResultsData[index],
                            nodeType: childNodeType
                        });
                    });
                });
        });
    }

    private getChildrenData$(childrenNodesIds: Array<string>) {
        return this.store$.pipe(select(selectNodeCreationInfoById(childrenNodesIds)),
            map(nodeCreationInfoArray => without(lodashMap(nodeCreationInfoArray, 'data'), null, undefined)),
            take(1));
    }
}
